import { Popup } from "@/components/popups/Popup";
import "./style/DeleteAccount.scss";
import { showNotification } from "@/components/notifications/Notifications";
import { apiMain } from "@/common/services";
import { onCloseDeleteAccount } from "@/components/popup-dispatcher/PopupDispatcher/emitters";

export const DeleteAccount = () => {
  const handleDelete = async (): Promise<void> => {
    try {
      await apiMain.deleteMyAccount();
      showNotification({
        variant: "success",
        title: "Please check your mailbox to continue."
      });
    } catch {
      showNotification({
        variant: "error",
        title: "Error deleting account, please try again in a few hours"
      });
    } finally {
      onCloseDeleteAccount();
    }
  };

  return (
    <Popup
      isOpen
      title="Delete Account"
      popupClass="DeleteAccount"
    >
      <p className="DeleteAccount-Description">
        If you continue, your account will be permanently deleted. This action is final and cannot be undone.
        <br />
        <br />
        Click "Delete My Account" to proceed. We'll send you an email with the final steps.
      </p>
      <div className="DeleteAccount-Buttons">
        <button onClick={onCloseDeleteAccount} className="DeleteAccount-Cancel" aria-label="cancel delete account">I'll Stay</button>
        <button onClick={handleDelete} className="DeleteAccount-Confirm" aria-label="confirm delete account">Delete My Account</button>
      </div>
    </Popup>
  );
};
